import { Injectable } from '@angular/core';

@Injectable()
export class DateService {
	constructor() {
	}

	getLocalDate(date: Date | string): Date {
		let localDate = new Date(date);
		return localDate;
	}

	today() {
		return this.getDate(new Date());
	}

	getDate(date: Date | string): Date {
		return new Date(this.getLocalDate(date).getFullYear() +
			'-' +
			('0' + (this.getLocalDate(date).getMonth() + 1)).substr(('0' + (this.getLocalDate(date).getMonth() + 1)).length - 2, 2) +
			'-' +
			('0' + this.getLocalDate(date).getDate()).substr(('0' + this.getLocalDate(date).getDate()).length - 2, 2));
	}

	getDiffInDays(fromDate: Date | string, toDate: Date): number {
		return (this.getDate(fromDate).getTime() - this.getDate(toDate).getTime()) / 86400000;
	}

	getDiffInMonths(fromDate: Date, toDate: Date): number {
		let months = (this.getDate(toDate).getFullYear() - this.getDate(fromDate).getFullYear()) * 12;
		months -= this.getDate(fromDate).getMonth();
		months += this.getDate(toDate).getMonth();
		return months;
	}

	/**
	 * Gets next birth day from a given date.
	 * @param now The date from which to calculate the next birthday
	 * @param birthday The date of birth (e.g. startDate)
	 * @returns The next birthday
	 * @example nextBirthday("2023-08-12", "2017-05-05") => 2024-05-05
	 */
	nextBirthday(now: Date, birthday: Date) {
		let nextBirthday = new Date(now.getFullYear(), birthday.getMonth(), birthday.getDate());
		
		while (nextBirthday <= now)
			nextBirthday = this.addYears(nextBirthday, 1);

		return nextBirthday;
	}

	nextBirthdays(startDate: Date, birthday: Date, limit: number) {
		const birthdays = [];
		let nextBirthday = this.nextBirthday(startDate, birthday);
		for (let i = 0; i < limit; i++) {
			birthdays.push(nextBirthday);
			nextBirthday = this.nextBirthday(nextBirthday, birthday);
		}

		return birthdays;
	}

	addDays(date: Date | undefined, days: number) {
		const result = date ? new Date(date) : new Date();
		result.setDate(result.getDate() + days);
		return result;
	}

	addMonths(date: Date | undefined, months: number) {
		const result = date ? new Date(date) : new Date();
		result.setMonth(result.getMonth() + months);
		return result;
	}

	addYears(date: Date | undefined, years: number) {
		const result = date ? new Date(date) : new Date();
		const leapDay = result.getMonth() === 1 && result.getDate() === 29;
		result.setFullYear(result.getFullYear() + years);
		if (leapDay && result.getMonth() !== 1) {
			// When adding years to a leap day, set the date to Feb 28 if the resulting year is not a leap year.
			// JavaScript Date object auto - adjusts Feb 29 to Mar 1 in non - leap years, but we want consistency with the .NET backend.
			result.setDate(28);
			result.setMonth(1);
		}
		return result;
	}
}
